module.exports = __webpack_public_path__ + "img/1489619537.2284015d.jpg";